import script from "./html-to-pdf.vue?vue&type=script&setup=true&lang=js"
export * from "./html-to-pdf.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__